import { Component, ErrorInfo, ReactNode } from "react";

type RouteErrorBoundaryProps = {
  children: ReactNode;
};

type RouteErrorBoundaryState = {
  message: string;
};

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
  state: RouteErrorBoundaryState = {
    message: "",
  };

  static getDerivedStateFromError(error: unknown): RouteErrorBoundaryState {
    return {
      message: error instanceof Error && error.message ? error.message : "页面运行异常",
    };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("Teacher Web route error", error, info.componentStack);
  }

  render() {
    if (this.state.message) {
      return (
        <section className="card route-error-card">
          <p className="eyebrow">Runtime</p>
          <h3>页面运行异常</h3>
          <p>{this.state.message}</p>
          <button className="ghost-button" type="button" onClick={() => window.location.reload()}>
            重新加载
          </button>
        </section>
      );
    }

    return this.props.children;
  }
}
